/* eslint-disable */
export default {
  _daytime_bg: 'daytime_bg',
  _LandscapeMainBackground_4x3: 'LandscapeMainBackground_4x3',
  _Grass: 'Grass',
  _pumpkin_inside1: 'pumpkin_inside1',
  _pumpkin_outside1: 'pumpkin_outside1',
  _Moon: 'Moon',
  _nighttime_bg: 'nighttime_bg',
  _Hills: 'Hills',
  _Hills_Night: 'Hills_Night',
  _MoonGlow: 'MoonGlow',
  _Pumpkin_3_shadow: 'Pumpkin_3_shadow',
  _pumpkin_inside3: 'pumpkin_inside3',
  _pumpkin_outside3: 'pumpkin_outside3',
  _Pumpkin_2_shadow: 'Pumpkin_2_shadow',
  _Pumpkin_1_shadow: 'Pumpkin_1_shadow',
  _pumpkin_outside2: 'pumpkin_outside2',
  _pumpkin_inside2: 'pumpkin_inside2',
  _LightGlow: 'LightGlow',
  _Tree: 'Tree',
  _NightCloud_1: 'NightCloud_1',
  _bat_animation_2: 'bat_animation/2',
  _House: 'House',
  _bat_animation_8: 'bat_animation/8',
  _Cat: 'Cat',
  _bat_animation_5: 'bat_animation/5',
  _bat_animation_1: 'bat_animation/1',
  _Sun: 'Sun',
  _Fence: 'Fence',
  _bat_animation_3: 'bat_animation/3',
  _bat_animation_0: 'bat_animation/0',
  _bat_animation_4: 'bat_animation/4',
  _bat_animation_7: 'bat_animation/7',
  _Candle: 'Candle',
  _bat_animation_6: 'bat_animation/6',
  _bat_animation_9: 'bat_animation/9',
  _Leaf_5: 'Leaf_5',
  _Cloud_1: 'Cloud_1',
  _Leaf_7: 'Leaf_7',
  _Leaf_1: 'Leaf_1',
  _Leaf_2: 'Leaf_2',
  _BtnGo: 'BtnGo',
  _BtnLight: 'BtnLight',
  _BtnLightOff: 'BtnLightOff',
  _BtnReset: 'BtnReset',
  _BtnUndo: 'BtnUndo',
  _Leaf_4: 'Leaf_4',
  _BtnDaytime: 'BtnDaytime',
  _Leaf_6: 'Leaf_6',
  _BtnNighttime: 'BtnNighttime',
  _Leaf_3: 'Leaf_3',
  _Flame_1: 'Flame_1',
  _Flame_2: 'Flame_2',
  _WindowGhost: 'WindowGhost',
  _WindowHead: 'WindowHead',
}